import styled from 'styled-components';
import { spacing, body2, colors } from 'ui/theme';

export const CountFilterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: ${spacing.quarter};
`;

export const CountFilterTextWrapper = styled.div`
  ${body2};
  color: ${colors.textSecondary};
`;
